module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "resetPassword"
    }
  }, [_c('mt-header', {
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "title": _vm.title
    }
  }, [_c('router-link', {
    attrs: {
      "slot": "left",
      "to": _vm.path
    },
    slot: "left"
  }, [_c('mt-button', [_c('img', {
    staticStyle: {
      "margin-left": "12px"
    },
    attrs: {
      "slot": "icon",
      "src": require("../../../assets/icon/back.png"),
      "height": "auto",
      "width": "8px"
    },
    slot: "icon"
  })])], 1)], 1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "height": "1px",
      "background-color": "#d8d8d8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "resetPassword-content"
  }, [(_vm.type === 'editPassword') ? _c('div', {
    staticClass: "textfield-view"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.originalPassword),
      expression: "originalPassword"
    }],
    staticClass: "textfield",
    staticStyle: {
      "color": "#191919"
    },
    attrs: {
      "type": "password",
      "placeholder": "请输入原密码"
    },
    domProps: {
      "value": (_vm.originalPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.originalPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "height": "1px",
      "background-color": "#666666"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "textfield-view"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "textfield",
    staticStyle: {
      "color": "#191919"
    },
    attrs: {
      "type": "password",
      "placeholder": "设置8-20位登录密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "height": "1px",
      "background-color": "#666666"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "textfield-view"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordAgain),
      expression: "passwordAgain"
    }],
    staticClass: "textfield",
    staticStyle: {
      "color": "#191919"
    },
    attrs: {
      "type": "password",
      "placeholder": "重复密码"
    },
    domProps: {
      "value": (_vm.passwordAgain)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordAgain = $event.target.value
      }
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "height": "1px",
      "background-color": "#666666"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.commit
    }
  }, [_vm._v("\n      确定\n    ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-355eab93","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mine/userAccountSet/resetPassword.vue
// module id = 563
// module chunks = 1